export const GTMResetSearch = () => {
  const w = window as any

  w.dataLayer = w.dataLayer || []
  w.dataLayer.push({ search: null })
}
